const convertToOptions = (result, query, value0, label0) => {
    result = result.data[query];
    var options
    if (value0 === undefined)
        options = [];
    else
        options = [{ value: value0, label: label0 }];
    result.forEach((obj, i) => {
        var option = {};
        if (typeof obj === 'string' || obj instanceof String) {
            option['value'] = obj;
            option['label'] = obj;
        } else {
            option['value'] = obj[1];//obj[0];
            option['label'] = obj[1];
        }
        options = options.concat(option);
    });
    return options;
}

export default convertToOptions;